// extracted by mini-css-extract-plugin
export var aircallIframe = "_h0-3";
export var fabContainer = "_h0-5";
export var fabRinging = "_h0-6";
export var loadingOverlay = "_h0-4";
export var pulse = "_h0-7";
export var widgetContent = "_h0-2";
export var widgetPanel = "_h0-0";
export var widgetPanelExpanded = "_h0-1";